import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpSectionStep のスタイル
 */
export const hotlineLpSectionStepStyle = tv({
    slots: {
        backgroundImage1: [
            'absolute -z-10',
            'w-[618px] left-[-340px] top-[-125px]',
            'lg:w-[1230px] lg:left-[-1090px] lg:bottom-[-125px]',
        ],
        backgroundImage2: [
            'absolute -z-10',
            'w-[180px] right-[-70px] bottom-[500px]',
            'lg:w-[363px] lg:right-[-250px] lg:top-[-200px]',
        ],
        base: [],
        button: ['mt-40 lg:mt-[70px]', 'text-center'],
        imageMeeting: ['w-full md:max-w-[665px] lg:max-w-[960px]'],
        imageWomen: [
            'absolute',
            'xl:right-[-160px] xl:bottom-[-52px]',
            'right-[-20px] bottom-[-20px]',
            'xl:w-[38%] w-[28.5%]',
        ],
        imageWrapper: [
            'mt-[-10px] sm:mt-24 lg:mt-40 xl:mt-[10px] max-lg:mx-[20px] flex items-center justify-center',
        ],
        listBorder: ['w-[1px] h-full bg-[#A6C3F2]', '[li:last-child_&]:hidden'],
        listCircle: [
            'size-[10px] lg:size-[12px] bg-[#4881F1] rounded-full',
            'relative flex items-center justify-center',
            'shrink-0',
            'before:size-[20px] lg:before:size-[24px] before:bg-[#4881F1] before:rounded-full before:opacity-20 before:content-[""]',
            'before:absolute',
        ],
        listCircleWrapper: [
            'flex flex-col items-center gap-y-[9px] lg:gap-y-[10px]',
            'shrink-0',
            'translate-y-[6px] lg:translate-y-[15px]',
        ],
        listDescription: [
            'text-[14px] lg:text-[16px] text-[#231916]',
            'mt-12 lg:mt-16',
            'leading-[21px] lg:leading-[29px]',
            'min-h-[98px] sm:min-h-[68px] lg:min-h-[88px]',
        ],
        listItemWrapper: ['flex gap-x-12 lg:gap-x-[22px]'],
        listTitle: [
            'text-[16px] lg:text-[24px] font-bold text-[#231916]',
            'leading-[24px] lg:leading-[43px]',
        ],
        listWrapper: [
            'max-lg:mt-[42px] max-lg:ml-[41px] max-lg:mr-[34px]',
            'flex flex-col gap-y-[9px] lg:gap-y-[10px]',
            'relative',
            'xl:min-w-[656px]',
        ],
        textWrapper: [
            'flex max-lg:flex-col lg:gap-x-104 max-lg:items-center',
            'lg:max-w-[1180px] lg:mx-auto lg:px-32',
        ],
        titleDescription: [
            'text-[14px] lg:text-[18px] text-[#231916]',
            'text-center lg:text-left',
            'leading-[25.2px] lg:leading-[36px]',
        ],
        titleWrapper: [
            'flex flex-col items-center gap-y-12 lg:gap-y-24 lg:items-start lg:min-w-[361px]',
        ],
    },
});
